// extracted by mini-css-extract-plugin
export var emailBlockLink = "_gk-0";